<template>
  <div class="delivery-container">
    <v-chip
      label
      outline
      color="red darken-2"
      text-color="metalGreyDark"
      class="body-2 delivery-chip"
    >
      給油データ登録日：<span class="subheading font-weight-bold">{{ !!lastUpdatedAt?lastUpdatedAt:'なし' }}</span>
    </v-chip>
    <v-card flat>
      <v-card-title>
        <h3 class="font-weight-light text-xs-center grow yellow lighten-4">
          本日の配送
        </h3>
      </v-card-title>
      <v-card-text class="summary-table">
        <div class="summary-box summary-title">
          配送回数
        </div>
        <div class="summary-box summary-text">
          {{ selectedNum }}回
        </div>
        <div class="summary-box summary-title">
          配送量
        </div>
        <div class="summary-box summary-text">
          {{ setCommas(selectedOilingCapacity) }}ℓ
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { setCommas } from '@/utils/helpers.js'
export default {
  computed: {
    ...mapGetters('list', ['selectedNum', 'selectedOilingCapacity']),
    ...mapState('dashboard', ['lastUpdatedAt'])
  },
  methods: {
    setCommas (v) {
      return setCommas(v)
    }
  }
}
</script>

<style lang="scss" scoped>
.delivery-container {
  position: relative;
  display: grid;
}
/deep/.delivery-chip {
  position: absolute;
  top: 0;
  right: 0;
  transform: translateY(-125%);
}
</style>
